module.exports = __webpack_public_path__ + "static/img/phonebanner.48c6b8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phonebanner.jpg
// module id = ZeMt
// module chunks = 1